import Link from 'components/Router/Link'
import { Container } from './styled'

function Icon({
  className,
  component: IconComponent,
  onClick,
  onMouseEnter,
  onMouseLeave,
  style,
  htmlTag,
  linkTo,
  to,
  dataTestId,
}) {
  return (
    <Container
      data-testid={dataTestId}
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
      as={linkTo || to ? Link : htmlTag}
      navigateTo={linkTo || to}
    >
      <IconComponent />
    </Container>
  )
}

export default Icon
